import styled from 'styled-components'

import { SECONDARY_LIGHTEST_COLOR } from '@CSSVars/colors'


export const _NoResult = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  left: 0;
  text-align: left;
  background-color: ${SECONDARY_LIGHTEST_COLOR};
  padding: 1rem 0.75rem 1rem .75rem;
  transition: all .3s;
  text-decoration: none;
  color: white;
  font-weight: bold;
`
